import { ChangeDetectionStrategy, Component, effect, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule, FormControl } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule, SelectModule } from '@hglobal/common';
import { PreferencesStore } from '@pt/store';

@Component({
  selector: 'pt-language-change',
  templateUrl: './language-change.component.html',
  styleUrl: './language-change.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    SelectModule,
    ButtonModule,
  ],
})
export class LanguageChangeComponent {
  #preferencesStore = inject(PreferencesStore);

  availableLanguages = this.#preferencesStore.languages;
  currentLanguage = this.#preferencesStore.currentLanguage;

  languageControl = new FormControl<number>(null);

  languageChangeEffect$ = effect(() => {
    if (this.currentLanguage()?.id) {
      this.languageControl.setValue(this.currentLanguage()?.id);
    }
  });

  changeLanguage() {
    this.#preferencesStore.updatePreferences({
      languageId: this.languageControl.value,
    });
  }
}
